export default "__VITE_ASSET__DScGgO6W__"